import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import 'react-big-calendar/lib/less/styles.less';
import 'react-toggle-switch/dist/css/switch.min.css';
import 'rc-drawer/assets/index.css';
import 'styles/bootstrap.scss';
import 'styles/app.scss';
import 'styles/app-rtl.scss';
import AppLocale from '../lngProvider';
import { NotificationContainer } from 'react-notifications';
import MainApp from 'app/index';
import SignIn from './SignIn';
import RestorePassword from './RestorePassword';
import MeldooWeb from './MeldooWeb';
import MailResponse from './MailResponse';
import PasswordRecovery from './PasswordRecovery';
import { setInitUrl } from '../actions/Auth';
import asyncComponent from 'util/asyncComponent';
import { updateWindowWidth } from '../actions/Setting';
import SetUpForm from './SetUpForm';
const RestrictedRoute = ({ component: Component, authUser, loggedIn, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            authUser && loggedIn ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: '/signin',
                        state: { from: props.location }
                    }}
                />
            )
        }
    />
);

class App extends Component {
    UNSAFE_componentWillMount() {
        if (this.props.initURL === '') {
            this.props.setInitUrl(this.props.history.location.pathname);
        }
    }

    componentDidMount() {
        window.addEventListener('resize', () => {
            this.props.updateWindowWidth(window.innerWidth);
        });
    }

    render() {
        const { match, location, locale, authUser, initURL, isDirectionRTL, loggedIn, role } = this.props;
        if (location.pathname === '/setup') return <SetUpForm />;
        if (location.pathname === '/') {
            if (authUser === null) {
                return <Redirect to={'/signin'} />;
            } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
                return role === 1 ? <Redirect to={'/app/admin-dashboard'} /> : <Redirect to={'/app/dashboard'} />;
            } else {
                return <Redirect to={initURL} />;
            }
        }
        // for RTL Support
        if (isDirectionRTL) {
            document.body.classList.add('rtl');
        } else {
            document.body.classList.remove('rtl');
        }
        const currentAppLocale = AppLocale[locale.locale];
        return (
            <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
                <div className="app-main">
                    <Switch>
                        <RestrictedRoute path={`${match.url}app`} authUser={authUser} loggedIn={loggedIn} component={MainApp} />
                        <Route path="/signin" component={SignIn} />
                        <Route path="/restore" component={RestorePassword} />
                        <Route path="/meldoo-web/:organisationkey?/:parameter?/:reportId?" component={MeldooWeb} />
                        <Route path="/mailresponse/:reportId?/:responsekey?" component={MailResponse} />
                        <Route path="/passwordrecovery/:userId/:key?" component={PasswordRecovery} />
                        <Route component={asyncComponent(() => import('components/Error404'))} />
                    </Switch>
                    <NotificationContainer />
                </div>
            </IntlProvider>
        );
    }
}

const mapStateToProps = ({ settings, auth, profile }) => {
    const { locale, isDirectionRTL } = settings;
    const { authUser, initURL, loggedIn } = auth;
    const { role } = profile.myUserProfile;
    return { locale, isDirectionRTL, authUser, initURL, loggedIn, role };
};

export default connect(
    mapStateToProps,
    { setInitUrl, updateWindowWidth }
)(App);



// WEBPACK FOOTER //
// ./containers/App.js